import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

export default function P83ThankYou({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.04);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.03);

  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden bg-background-50">
      {/* 背景光晕 */}
      <div ref={orb1Ref} className="absolute top-16 left-1/2 -translate-x-1/2 w-[42rem] h-[42rem] rounded-full bg-primary-100/10 blur-[150px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-20 right-12 w-80 h-80 rounded-full bg-accent-100/8 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center" ref={titleRef}>
        {/* 顶部装饰线 + 标签 */}
        <div className={`flex items-center justify-center gap-4 mb-6 md:mb-8 transition-all duration-1000 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="h-px w-12 md:w-16 bg-gradient-to-r from-transparent to-primary-300/50" />
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200/40 text-xs font-body font-semibold text-primary-600 uppercase tracking-[0.15em]">
            <i className="ri-emotion-happy-line text-sm" />
            感谢您的关注
          </span>
          <div className="h-px w-12 md:w-16 bg-gradient-to-l from-transparent to-primary-300/50" />
        </div>

        {/* 主标题 */}
        <h2
          className={`font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 mb-4 md:mb-6 transition-all duration-1000 delay-100 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          谢谢聆听
        </h2>

        {/* 副标题 */}
        <p
          className={`text-lg md:text-xl text-foreground-950 font-body max-w-2xl mx-auto leading-relaxed mb-10 md:mb-14 transition-all duration-1000 delay-200 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          期待与您共同探索 AI 评课在教育质量提升中的更多可能
        </p>

        {/* 中间装饰线 */}
        <div className={`flex items-center justify-center gap-3 mb-10 md:mb-14 transition-all duration-1000 delay-500 ${titleVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="h-px w-20 md:w-28 bg-gradient-to-r from-transparent via-accent-300/40 to-transparent" />
          <div className="w-2 h-2 rounded-full bg-accent-300/40" />
          <div className="h-px w-20 md:w-28 bg-gradient-to-l from-transparent via-accent-300/40 to-transparent" />
        </div>

        {/* 底部交流区 */}
        <div className={`flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 transition-all duration-1000 delay-600 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-accent-50/60 backdrop-blur-md border border-accent-200/30 hover:border-accent-300/50 transition-colors">
            <div className="w-9 h-9 rounded-lg bg-accent-100 border border-accent-200/40 flex items-center justify-center flex-shrink-0">
              <i className="ri-question-answer-line text-base text-accent-600" />
            </div>
            <span className="text-sm font-body text-foreground-950">欢迎提问与交流</span>
          </div>
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-primary-50/60 backdrop-blur-md border border-primary-200/30 hover:border-primary-300/50 transition-colors">
            <div className="w-9 h-9 rounded-lg bg-primary-100 border border-primary-200/40 flex items-center justify-center flex-shrink-0">
              <i className="ri-user-heart-line text-base text-primary-600" />
            </div>
            <span className="text-sm font-body text-foreground-950">期待合作与共创</span>
          </div>
        </div>

        {/* 底部小字 */}
        <p
          className={`text-xs text-foreground-950 font-body mt-8 md:mt-12 transition-all duration-1000 delay-800 ${titleVisible ? 'opacity-100' : 'opacity-0'}`}
        >
          AI思政评课 · 让每一堂课都有据可依
        </p>
      </div>
    </div>
  );
}